import React from 'react';
import ArticleSection from '../components/ArticleSection';
import copy from '../copy/ArticleTwoCopy';
import Button from '../components/Button';
import '../stylesheets/E.scss';

export default function E() {
  return (
    <article className="e">
      <section className="top-section">
        <h1>Wealth Diaries</h1>
        <h2>Five people&#8212;with very different backgrounds&#8212;are reimagining wealth and finding financial happiness.</h2>
        <p>
          For most of us, the journey toward financial freedom is a winding one. We plan, we rethink, and we change directions until, finally, we find ourselves on a path that
          feels right. Sometimes, it happens quickly. Other times, it’s a lifelong process. With that in mind, we spoke to several people—all of them at different places on their
          journey— about how they’ve defined their values, and what wealth really means to them.
        </p>
      </section>
      <div className="line"></div>
      <ArticleSection copy={copy} sectionNumber={1} />
      <div className="line"></div>

      <ArticleSection copy={copy} sectionNumber={3} />
      <div className="line"></div>

      <ArticleSection copy={copy} sectionNumber={2} />
      <div className="line"></div>

      <ArticleSection copy={copy} sectionNumber={4} />
      <div className="line"></div>

      <ArticleSection copy={copy} sectionNumber={5} />
      <div className="line"></div>

      <section className="bottom-section">
        <p>
          Whether you’re just starting down the path or looking back on a road well traveled, making good financial choices for the future means having an understanding of what
          true wealth means to you. With John Hancock, we can help you plan for your future no matter how you define it.{' '}
        </p>
      </section>
      <Button
        message={'Get Started'}
        link={
          'https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.263999094;dc_trk_aid=459014988;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua='
        }
      />

      <section className="disclosure">
        <p>Financial planning and investment advice provided by John Hancock Personal Financial Services, LLC (“JHPFS”), an SEC registered investment adviser.</p>
        <p>The individuals depicted in this article are not clients of JHPFS.</p>
      </section>
    </article>
  );
}
